<div id="layout-wrapper">

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()" (chatSidebarToggled)="onToggleChatSidebar()" (supplierChatSidebarToggled)="onToggleSupplierChatSidebar()">
  </app-topbar>

  <app-sidebar [isCondensed]="isCondensed" (chatSidebarToggled)="onToggleChatSidebar()"></app-sidebar>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->
    <app-footer></app-footer>
  </div>
</div>

<app-rightsidebar></app-rightsidebar>
<app-chad-sidebar [isOpen]="isChatSidebarOpen" (closeSidebarEvent)="onCloseChatSidebar()"></app-chad-sidebar>
<app-chatsidebar2 [isOpen]="isSupplierChatSidebarOpen" (closeSidebarEvent)="onCloseSupplierChatSidebar()"></app-chatsidebar2>
